__turbopack_context__.v({
  "brand": "Footer-module__zj-tQq__brand",
  "grid": "Footer-module__zj-tQq__grid",
  "legal": "Footer-module__zj-tQq__legal",
  "links": "Footer-module__zj-tQq__links",
});
